import {feed_fetchFeedByContainer_Api} from 'apis'
import {getId, getType} from 'apis/model/base'
import {renderEmptyHolder} from 'components/EmptyHolder'
import Pure from 'components/Pure'
import _ from 'lodash'
import {permissionCodes} from 'modules/permissions/contants'
import PermissionProvider from 'modules/permissions/PermissionProvider'
import React, {useContext, useMemo} from 'react'
import {useLocation} from 'react-router-dom'
import {nest} from 'recompose'
import EntityList from 'views/AppLocals/EntityList'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import {renderFeedItem} from 'views/MainPage/functions/renderFeedItem'
import {NullAsDefault, renderIf} from 'views/Shared'
import CourseContext from '../../CourseContext'
import GenericPostForm from "../../../../../components/Feed/PostForm/GenericPostForm";

const CourseNewsTab = ({Footer = NullAsDefault}) => {
    const location = useLocation()

    const {refreshToken} = location.state ?? {}

    const {item} = useContext(CourseContext)

    const [id, prop] = [getId(item), getType(item)]

    const apiInfo = feed_fetchFeedByContainer_Api

    const refreshKey = useMemo(
        () =>
            [
                apiInfo.path.replace(':id', id).replace(':prop', prop),
                `refreshToken=${refreshToken}`,
            ].join('?'),
        [id, prop, refreshToken]
    )

    const {channel, available_actions} = item ?? {}

    const container = {
        id: getId(channel),
        type: getType(channel),
    }

    return renderIf(
        item,
        <div className="flex flex-col items-start space-y-6">
            <div className="space-y-3 w-full">
                <PermissionProvider
                    permissions={{
                        [permissionCodes.canPost]: _.get(
                            available_actions,
                            permissionCodes.canPost
                        ),
                    }}>
                    <GenericPostForm container={container} defaultChannel={channel}/>
                </PermissionProvider>
                <EntityList
                    key={refreshKey}
                    apiInfo={apiInfo}
                    refreshKey={refreshKey}
                    renderItem={renderFeedItem}
                    RenderEntity={React.Fragment}
                    renderEmpty={renderEmptyHolder}
                    query={bindQueryParams([{id}, {prop}])}
                    renderWrap={(child, __, count) => (
                        <div className="space-y-3">
                            {child}
                            {count ? <Footer/> : null}
                            <div className="h-12"/>
                        </div>
                    )}
                />
            </div>
        </div>
    )
}

export default nest(Pure, CourseNewsTab)
